import CreateIcon from '@mui/icons-material/Create';
import { ReactElement, ReactNode, SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';

import { CUSTOM_LINK_ICONS } from 'constants/index';
import { CreateButton } from 'features/documentCategories/components/DocumentCategories/styled';
import { useAuth } from 'hooks';
import { Links } from 'settings';
import { theme } from 'styles';
import { QuickLink as IQuickLink, QuickLinkAccess } from 'types';

import { LINKS_ICONS } from '../../constants';
import { CardW, IconW, RowW, SubtitleW, TitleW } from './styled';

interface QuickLinkProps extends IQuickLink {
  children?: ReactNode;
  isEditable?: boolean;
  isDragging?: boolean;
}

export function QuickLink({
  title,
  icon,
  children,
  url,
  id,
  isEditable = false,
  isDragging,
  access,
  author_id,
}: QuickLinkProps): ReactElement {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isManager, user: currentUser } = useAuth();

  const isPublicLink = access === QuickLinkAccess.public;
  const isPublicEditable = isPublicLink && isManager && author_id === currentUser?.id && isEditable;
  const editable = isEditable && (isPublicEditable || !isPublicLink);

  const ICONS = { ...LINKS_ICONS, ...CUSTOM_LINK_ICONS };
  const detailsLink = generatePath(Links.we.quickLinks.linkDetails, {
    linkId: id,
  });

  function handleClick() {
    if (isDragging) {
      return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  function handleEditBtnClick(e: SyntheticEvent) {
    e.stopPropagation();
    navigate(detailsLink);
  }

  return (
    <CardW onClick={handleClick}>
      <RowW>
        <IconW>{ICONS[icon]}</IconW>
        <div>
          <TitleW>{title}</TitleW>
          {isPublicLink && isEditable && <SubtitleW>{t('quickLinks.publicLink')}</SubtitleW>}
        </div>
        {editable && (
          <CreateButton
            startIcon={
              <CreateIcon style={{ fill: theme.palette.common.white, marginLeft: '8px' }} />
            }
            onClick={handleEditBtnClick}
            style={{
              padding: '8px',
              backgroundColor: theme.palette.info.main,
              color: theme.palette.common.white,
              fontSize: '14px',
              fontWeight: 400,
              borderRadius: '8px',
              textTransform: 'none',
            }}
          />
        )}
      </RowW>
      {children}
    </CardW>
  );
}
